import { render, staticRenderFns } from "./model-settings.vue?vue&type=template&id=b27381bc&scoped=true"
import script from "./model-settings.vue?vue&type=script&lang=js"
export * from "./model-settings.vue?vue&type=script&lang=js"
import style0 from "./model-settings.vue?vue&type=style&index=0&id=b27381bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27381bc",
  null
  
)

export default component.exports